import {
  Box,
  Button,
  Grid,
  GridColumn,
  Text,
  TextField,
  ThemeProvider,
  ThemeSizes
} from "@modernatx/ui-kit-react";
import React from "react";

import { useAuth } from "@/hooks/useAuth";

const InternalLoginPage = () => {
  const [value, setValue] = React.useState("");
  const [error, setError] = React.useState<string | undefined>(undefined);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [processing, setProcessing] = React.useState(false);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const setInvalidPassword = (_val: string) => {
    return;
  };
  const { signIn } = useAuth({ setInvalidPassword, setProcessing });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!value.endsWith("@modernatx.com")) {
      setError("Moderna email address required");
    } else {
      try {
        signIn(value);
      } catch (err) {
        setError("An error occurred while signing in. Please try again.");
      } finally {
        setIsSubmitting(true);
      }
    }
  };

  return (
    <ThemeProvider>
      <Box
        sx={{
          backgroundColor: "surface-neutral-secondary",
          pt: "spacing-9",
          pb: "spacing-12",
          display: "flex",
          alignItems: "center",
          minHeight: "60vh" as ThemeSizes
        }}
      >
        <Grid>
          <GridColumn size={[4, 6, 6]} push={[0, 1, 3]}>
            <Text sx={{ py: "spacing-9" }}>
              Please log in to continue. You will need a Moderna Direct account
              even if you have an account on other Moderna sites.
            </Text>
            <Box as="form" onSubmit={handleSubmit} noValidate={true}>
              <TextField
                label="Enter your Email"
                value={value}
                type="email"
                description="Email"
                onChange={handleChange}
                onEnter={handleSubmit as () => void}
                error={error}
                disabled={isSubmitting || processing}
              />
              <Grid>
                <GridColumn size={[4, 3, 3]} push={[0, 3, 3]}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "spacing-3",
                      pt: "spacing-9"
                    }}
                  >
                    <Button type="submit" disabled={isSubmitting || processing}>
                      Continue
                    </Button>
                  </Box>
                </GridColumn>
              </Grid>
            </Box>
          </GridColumn>
        </Grid>
      </Box>
    </ThemeProvider>
  );
};

export default InternalLoginPage;
